import './ResetPassword.css';
import React, { useEffect, useRef } from "react";
import { connect } from 'react-redux';
import { withTranslate } from 'react-redux-multilingual';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PasswordStrengthBar from 'react-password-strength-bar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

import {
    ValidatePassword,
} from '../../../libraries/Tool';

import {
    AuthResetPasswordToken,
    ResetPassword as ResetPasswordUser,
} from '../../../services/Auth.service';

function ResetPassword(props) {
    const { translate, SnackbarAlert } = props;
    const navigate = useNavigate();
    const { token } = useParams();
    const typingTimeoutRef = useRef(null);
    const [loading, setLoading] = React.useState(false);
    const [password, setPassword] = React.useState();
    const [passwordInvalid, setPasswordInvalid] = React.useState(false);
    const [confirmpassword, setConfirmpassword] = React.useState();
    const [confirmpasswordInvalid, setConfirmpasswordInvalid] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleOnChangePassword = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setPassword(e.target.value);
            setPasswordInvalid(!ValidatePassword(e.target.value));
        },500)
    }

    const handleOnChangeConfirmPassword = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setConfirmpassword(e.target.value);
            setConfirmpasswordInvalid(!ValidatePassword(e.target.value));
        },500)
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const onClickResetPassword = async (e) => {
        e.preventDefault();
        let event;
        if(!password) setPasswordInvalid(true);
        if(!confirmpassword) setConfirmpasswordInvalid(true);
        if(
            password &&
            confirmpassword &&
            !passwordInvalid &&
            !confirmpasswordInvalid
        ) {
            if (password !== confirmpassword) {
                setTimeout(() => {
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: 'error',
                            message: translate('passwordisnotmatch'),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                }, 1000)
            } else {
                setLoading(true);
                event = ResetPasswordUser({password, confirmpassword, token});
            }
        }
        event?.then(res => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
            setTimeout(() => {
                window.location.reload();
            }, 3000)
        })
        .catch(err => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        AuthResetPasswordToken(token)
        .catch(e => {
          navigate("/signin")
        })
    }, [])    

    return (
        <div>
            <Container maxWidth="md" sx={{ my: 20 }}>
                <Typography variant="h3" gutterBottom component="div">
                    {translate('resetyourpassword')}
                </Typography>
                <Typography variant="h6" gutterBottom component="div" sx={{ color: "#586978", mb: "3em" }}>
                    {translate('resetyourpassworddescription')}
                </Typography>
                <Box 
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1 },
                      }}
                    noValidate
                    autoComplete="off"
                    className="reset-password-box-main"
                    onSubmit={onClickResetPassword}
                >
                    <FormControl required fullWidth variant="outlined">
                        <OutlinedInput
                            id="new-password" 
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            onChange={handleOnChangePassword}
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                onClick={() => setShowPassword(!showPassword) }
                                onMouseDown={(event) =>  event.preventDefault() }
                                edge="end"
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                            label=""
                            placeholder={translate('newpassword')}
                            error={passwordInvalid}
                        />
                        {passwordInvalid && (
                        <FormHelperText error id="new-password" >
                        {translate('pleaseenteravalidpassword')}
                        </FormHelperText>)}
                    </FormControl>
                    <PasswordStrengthBar 
                        password={password}
                        scoreWords={[translate('weak'), translate('okay'), translate('good'), translate('strong'), translate('stronger')]}
                        minLength={8}
                        shortScoreWord={translate('tooshort')}
                    />
                    <FormControl required fullWidth variant="outlined">
                        <OutlinedInput
                            id="confirm-password" 
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            onChange={handleOnChangeConfirmPassword}
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                onClick={() => setShowPassword(!showPassword) }
                                onMouseDown={(event) =>  event.preventDefault() }
                                edge="end"
                                >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                            label=""
                            placeholder={translate('confirmpassword')}
                            error={confirmpasswordInvalid}
                        />
                        {confirmpasswordInvalid && (
                        <FormHelperText error id="confirm-password" >
                        {translate('pleaseenteravalidpassword')}
                        </FormHelperText>)}
                    </FormControl>
                    <PasswordStrengthBar 
                        password={confirmpassword}
                        scoreWords={[translate('weak'), translate('okay'), translate('good'), translate('strong'), translate('stronger')]}
                        minLength={8}
                        shortScoreWord={translate('tooshort')}
                    />
                    <LoadingButton
                        onClick={onClickResetPassword}
                        endIcon={<SendIcon />}
                        loading={loading}
                        loadingPosition="end"
                        variant="contained"
                        >
                        {translate('resetpassword')}
                    </LoadingButton>
                </Box>
            </Container>
        </div>
    )
}
function mapStateToProps(state) {
    return {
      SnackbarAlert: state.SnackbarAlert,
    }
}

export default connect(mapStateToProps)(withTranslate(ResetPassword));